import React__default from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ContactLensMetaData } from '../components/ContactLensMetaData.js';
import { ContactLensSpecs } from '../components/ContactLensSpecs.js';

const ContactLensSpecsContainer = ({ colorLens , replacementFrequency , packageQuantity , specs  })=>{
    const { getLabel  } = useIntl();
    const isTabletLandscapeUp = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.TABLET_LANDSCAPE;
    const labels = React__default.useMemo(()=>({
            productsUnitContactLenses: getLabel('products.unit.contactLenses'),
            productsPerBox: getLabel('products.perBox'),
            baseCurve: getLabel(`products.contactLenses.prescription.baseCurve`),
            baseCurveAbbr: getLabel(`products.contactLenses.prescription.baseCurve.abbr`),
            diameter: getLabel(`products.contactLenses.prescription.diameter`),
            diameterAbbr: getLabel(`products.contactLenses.prescription.diameter.abbr`),
            axis: getLabel(`products.contactLenses.prescription.axis`),
            axisAbbr: getLabel(`products.contactLenses.prescription.axis.abbr`),
            power: getLabel(`products.contactLenses.prescription.power`),
            powerAbbr: getLabel(`products.contactLenses.prescription.power.abbr`),
            cylinder: getLabel(`products.contactLenses.prescription.cylinder`),
            cylinderAbbr: getLabel(`products.contactLenses.prescription.cylinder.abbr`),
            addition: getLabel(`products.contactLenses.prescription.addition`),
            additionAbbr: getLabel(`products.contactLenses.prescription.addition.abbr`)
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(ContactLensMetaData, {
        colorLens: colorLens,
        replacementFrequency: replacementFrequency,
        packageQuantity: packageQuantity,
        labels: labels
    }), /*#__PURE__*/ React__default.createElement(ContactLensSpecs, {
        specs: specs,
        labels: labels,
        isTabletLandscapeUp: isTabletLandscapeUp
    }));
};

export { ContactLensSpecsContainer };
//# sourceMappingURL=ContactLensSpecsContainer.js.map
